import {z} from 'zod';

export const MerchantDisputeStatus=z.enum(['warning_needs_response','warning_under_review','warning_closed','needs_response','under_review','won','lost','prevented']);
export const MerchantDisputeSchema=z.object({
  id:z.uuid(),orderId:z.uuid(),amount:z.string().regex(/^\d+$/),currency:z.literal('USD'),
  status:MerchantDisputeStatus,reason:z.string(),createdAt:z.iso.datetime(),observedAt:z.iso.datetime(),
  respondBy:z.iso.datetime().nullable(),pastDue:z.boolean(),evidenceSubmitted:z.boolean(),
  blocksFulfillment:z.boolean(),submissionCount:z.number().int().nonnegative(),
}).strict();
export const MerchantDisputeOverviewSchema=z.object({
  disputes:MerchantDisputeSchema.extend({accountId:z.uuid(),profileName:z.string(),description:z.string()}).array(),hasMore:z.boolean(),
}).strict();
export type MerchantDispute=z.infer<typeof MerchantDisputeSchema>;
export type MerchantDisputeOverview=z.infer<typeof MerchantDisputeOverviewSchema>;
export const MerchantDisputeResponse=z.object({requestId:z.uuid(),action:z.enum(['save','submit']),
  submissionCount:z.number().int().nonnegative(),response:z.string().trim().min(1).max(150000),reason:z.string().trim().min(3).max(1000)}).strict();
export type MerchantDisputeResponseInput=z.infer<typeof MerchantDisputeResponse>;
export const merchantDisputeLabel=(status:MerchantDispute['status'])=>({
  warning_needs_response:'Inquiry needs a response',warning_under_review:'Inquiry under review',warning_closed:'Inquiry closed',
  needs_response:'Response required',under_review:'Under review',won:'Won',lost:'Lost',prevented:'Dispute prevented',
})[status];
